export const RealityCheckPeriodEnum = {
   '1' : 10,
   '2' : 20,
   '3' : 30,
   '4' : 40,
   '5' : 50,
   '6' : 60,
   '7' : 120,
   '8' : 180,
   '9' : 240,
   '10' : 300,
   '11' : 360,
   '12' : 480
}